import { useEffect, useLayoutEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import OneSignal from "react-onesignal";

import "@n8n/chat/style.css";
import "./App.css";
import "./assets/css/animate.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import "./assets/css/flaticons.css";
import "./component/global/global.css";

import { createChat } from "@n8n/chat";
import { navbarAnim } from "./assets/js/custom";

import AOS from "aos";
import "aos/dist/aos.css";
import { Navbar } from "./component/navbar";
import { Footer } from "./component/footer";
import { Home } from "./component/home";
import { Survey } from "./component/survey";
import { Signup } from "./component/signup";
import { Login } from "./component/login";
import api from "./api";
import userAction from "./redux/users/action";
import adminAction from "./redux/admin/action";

import notificationAction from "./redux/notification/action";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "./component/global/sidebar/sidebar";
import { NavbarAdmin } from "./component/global/navbar/navbar";
import Users from "./component/global/users";
import { AdminLogin } from "./component/global/adminlogin";
import AllSurvey from "./component/global/survey";
import PromotionMail from "./component/global/promotionMail";
import AddPost from "./component/global/addPost";
import AllAdminPost from "./component/global/allPostAdmin";
import { UserPost } from "./component/userPost";
import axios from "axios";
import { DataInfo } from "./component/global/dataInfo";
import { ForgetPass } from "./component/forgetPass";
import { ResetPass } from "./component/resetPass";
import { Portfolio } from "./component/portfolio/portfolio";
import LiquidityRadar from "./component/liquidityRadar/LiquidityRadar";
import { ConnectPage } from "./component/portfolio/connectPage";
import { PortfolioDashboard } from "./component/portfolio/dashboard/dashboard";
import TupLokersMail from "./component/global/lockersMail";
import LockersList from "./component/global/lockersList";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WagmiProvider } from "wagmi";
import { config } from "./helpers/wagmi";
import WalletUsers from "./component/global/walletUsers";
import { NavbarNew } from "./component/HomeNew/navbar";
import { HomeNew } from "./component/HomeNew";
import { FooterNew } from "./component/HomeNew/footerNew";
import PaidUsers from "./component/global/paidUsersAdmin";
import { Checkout } from "./component/payment/checkout";
import { PayHistoryUser } from "./component/payment/payHistoryUser";
import {
  AuthNotLoginRoutes,
  AuthOnlyUserRoutes,
  PermissionRoutes,
} from "./helpers/index";
import AdminBroadcast from "./component/global/adminBroadcast";
import { ContactSupport } from "./component/contactSupport";
import ContactSupAdmin from "./component/global/contactSupAdmin";
import AdminVideo from "./component/global/adminvideo";
import { AllAdminStocks } from "./component/global/adminStocks";
import { AllAdminMarket } from "./component/global/adminMarket";
import { CokieModal } from "./component/modals/cokieModal";
import { TermsAndConditions } from "./component/termsAndConditions";
import { PrivacyPolicy } from "./component/privacyPolicy";
import MailToPaidUsers from "./component/global/mailToPaidUser";
import { Loader } from "./component/global/loader";
import UnSubscribedUsers from "./component/global/unsubscribedUsers";
import { SuperAdminLogin } from "./component/global/superAdminLogin";
import AdminYearlyContact from "./component/global/adminYearlyContact";
import { useAlert } from "react-alert";
import AdminPaymentHistory from "./component/global/paymentHistory";
import AdminUserLogs from "./component/global/userLogs";
import MailToNonPaidUsers from "./component/global/mailToNonPaidUsers";
import AdminForgetPass from "./component/global/adminForgetPass";
import MailToBirthdayUsers from "./component/global/sendBirthdayMailToUser";
import SendPaidMail from "./component/global/sendPaidMail";
import { SupportAdminLogin } from "./component/global/supportLogin";
import UsersSupport from "./component/global/usersSupport";
import SupportPaidUsers from "./component/global/paidUserSupport";
import { SupportUser } from "./component/supportTicket/support";
import { CreateTicket } from "./component/supportTicket/createTicket";
import { Ticketdetail } from "./component/supportTicket/ticketdetail";
import Intercom from "@intercom/messenger-js-sdk";
import AdminSupportTicket from "./component/global/supportTicket";
import { TicketdetailAdmin } from "./component/global/supportTicketDetail";
import { DataInfoSupport } from "./component/global/dataInfoSupport";
import SendOTPMail from "./component/global/sendOTPMail";
import AdminSupportOnline from "./component/global/supportOnline";
import CustomMail from "./component/global/customEmail";
import { AddTemplate } from "./component/global/addTemplate";
import UsersConsent from "./component/global/usersConsent";
import { ConsentsModal } from "./component/modals/consentsModal";
import CustomPushNotification from "./component/global/sendPushNotification";
import { WaqarLogin } from "./component/global/waqarScreen/waqarLogin";
import { WaqarStats } from "./component/global/waqarScreen/stats";
import { YubitReferrals } from "./component/global/waqarScreen/yubitReferrals";
import { NoticeModal } from "./component/modals/eidModal";
// import { coonectMetamask } from "./helpers/wallet";
import { PaidFeedback } from "./component/modals/paidFeedbackModal";
import MemberFeedback from "./component/global/feedback/memberFeedback";
import SubscriptionConsent from "./component/global/subsConsents";
import SuperAdminAllSupport from "./component/global/allAdmins";
import DuplicateUsers from "./component/global/duplicateUsers";
import AdminSearchStripeSubs from "./component/global/checkStripeSubs";
import CheckCustomerDataStripe from "./component/global/checkStripeCustomerData";
import TradeSummary from "./component/global/tradeSummary";
import { AdminSummary } from "./component/global/adminSummary";
import { Indicators } from "./component/indicators";
import { MarketOverview } from "./component/marketOverview";
import SupportRecentActivity from "./component/global/supportActivity";
import { BlacklistEmail } from "./component/global/blacklistEmail";
import { UnauthTransaction } from "./component/unauthTransaction";
import UnAuthTransConsent from "./component/global/unauthTransConsent";
import EmailLogs from "./component/global/emailLogs";
import { CalculatorMain } from "./component/calculators";
import { TradeDirectory } from "./component/global/tradeDirectory";
import { PollAdmin } from "./component/global/poll";
import { PollModal } from "./component/modals/pollModal";
import AdminLiveSession from "./component/global/liveSessions";
import { BannerAdmin } from "./component/global/mobileApp/banner";
import { PushNotification } from "./component/global/mobileApp/pushNotifyLogs";
import { NoticeAdmin } from "./component/global/mobileApp/notice";
import TicketFeedbackAdmin from "./component/global/ticketFeedback";
import AdminLiveTrades from "./component/global/liveTrade/liveTrades";
import { LiveTradeLogin } from "./component/global/waqarScreen/liveTradeStats";
import AdminLiveTradesTV from "./component/global/liveTrade/liveTradeTradeview";
import ProfilePage from "./component/profile";
import DirectPaidUsers from "./component/global/directSubscriptions";
import { LoginUserByAdmin } from "./component/loginUserByAdmin";
import { AdminGodzilla } from "./component/global/godzilla";
import CheckGodzillaAccess from "./component/global/godzilla/godzillaAccessCheck";
import { AdminGeneral } from "./component/global/adminGeneral";
import UserPaidByAdmin from "./component/global/userPaidByAdmin";

// import { ChallengePlan } from "./component/global/challenge/challengePlan";
// import ChallengesAdmin from "./component/global/challenge/challenges";
// import ChallengesAdminByUserId from "./component/global/challenge/challengesByUserId";

const queryClient = new QueryClient();

function App() {
  const { setUser } = userAction;
  const { setAdmin } = adminAction;

  const { setNotification } = notificationAction;
  const dispatch = useDispatch();
  const alert = useAlert();
  const adminStore = useSelector((state) => state.adminReducer);
  const userStore = useSelector((state) => state.userReducer);

  const [loader, setLoader] = useState(false);

  const location = useLocation();
  const [show, setShow] = useState(false);
  const [SubsData, setSubsData] = useState({});
  const [adminType, setAdminType] = useState("");
  const [adminPermissions, setAdminPermissions] = useState([]);

  useEffect(() => {
    navbarAnim();
    AOS.init();
    AOS.refresh();
  }, []);

  const checkUserSession = async () => {
    try {
      let token = localStorage.getItem("token");
      // console.log(token);
      if (token) {
        let payload = { token: token };
        const registerationResponse = await api.verifySession(payload);
        // console.log(registerationResponse);
        if (registerationResponse?.token) {
          localStorage.setItem("token", registerationResponse?.token);
          axios.defaults.headers.common["Authorization"] =
            registerationResponse?.token;
          await checkSubs();
          await checkMessageNotification(); // ✅ call after new token is set
        } else if (
          registerationResponse?.isLoggedIn === false ||
          registerationResponse?.error === "Failed to Authenticate" ||
          registerationResponse?.error ===
            "Session expired or logged in elsewhere" ||
          registerationResponse?.error === "Incorrect token given" ||
          registerationResponse?.error === "Undefined Token"
        ) {
          alert.show(registerationResponse?.error);
          dispatch(setUser({}));
          alert.show("Session Expired");
          setSubsData({});
          localStorage.removeItem("token");
          setLoader(false);
          window.location.href = "/";
          return;
        }
      }
      setLoader(false);
    } catch (error) {
      // ✅ Network error / server down — do NOT logout, just continue silently
      console.error(
        "Session check failed (server may be down):",
        error?.message,
      );
      setLoader(false);
      // setLoader(false);
      // dispatch(setUser({}));
      // setSubsData({});
      // localStorage.removeItem("token");
      // window.location.href = "/";
    }
  };

  useLayoutEffect(() => {
    if (
      adminStore?.admin?.admin?.role == "mackAdmin777" ||
      adminStore?.admin?.admin?.role == "sackAdmin755" ||
      adminStore?.admin?.admin?.role == "jackAdmin775" ||
      adminStore?.admin?.admin?.role == "livetradestats"
    ) {
    } else {
      checkUserSession();
    }
  }, []);

  const checkSubs = async () => {
    try {
      if (userStore?.users?.user?._id) {
        setLoader(true);
        // console.log("checksubs");

        const res = await api.checkSubscription(userStore?.users?.user?._id);
        // console.log(res);

        if (res?.subscription) {
          let currentDate = new Date();
          let endDate = new Date(res?.subscription?.nextPayment);
          if (currentDate < endDate) {
            res.subscription.isSubscription = true;
            setSubsData(res?.subscription);
          } else {
            res.subscription.isSubscription = false;
            setSubsData(res?.subscription);
          }
        }
      }

      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };

  useEffect(() => {
    // OneSignal.init({ appId: process.env.REACT_APP_ONESIGNAL_APPID }).then(
    //   () => {
    //     console.log("prompt push notification");
    //     if (window.ios) {
    //       OneSignal.showNativePrompt();
    //     }
    //   }
    // );
  }, []);
  // useEffect(() => {
  //   // Initialize OneSignal with your App ID
  //   OneSignal.init({
  //     appId: process.env.REACT_APP_ONESIGNAL_APPID,
  //     notifyButton: {
  //       enable: true, // Enable OneSignal's notification button
  //     },
  //   });

  //   // Show the notification prompt manually on iOS
  //   if (window && window.ios) {
  //     OneSignal.Notifications.requestPermission();
  //   }
  // }, []);

  useEffect(() => {
    if (userStore?.users?.user?._id) {
      Intercom({
        app_id: "u3zetb7y",
        user_id: userStore?.users?.user?._id,
        name: userStore?.users?.user?.name,
        email: userStore?.users?.user?.email,
        membership_status: SubsData?.isSubscription ? "paid" : "nonpaid",
        // custom_attributes: {
        //   membership_status: SubsData?.isSubscription ? "paid" : "nonpaid",
        // },
      });
      // let iframe = document.querySelector(".intercom-lightweight-app-launcher");
      // let iframe1 = document.querySelector(".intercom-namespace");
      let text1 = document.getElementById("intercomHelpText");
      // console.log(text1);

      if (text1) {
        text1.style.display = "block";
      }
      // if (iframe) {
      //   iframe.style.top = "55% !important";
      // }
      // if (iframe1) {
      //   iframe.style.top = "55% !important";
      // }
    }
  }, [userStore?.users, SubsData]);

  const checkSuperAdminSession = async () => {
    try {
      let token = localStorage.getItem("token");
      // console.log(token);
      setLoader(true);
      if (token) {
        // check admin have valid wallet address
        // let wallet = await coonectMetamask();
        // if (!wallet) {
        //   alert.error("Wallet is required to login");
        //   return;
        // }
        // console.log(wallet);

        let payload = {
          token: token,
          // wallet,
        };
        const registerationResponse =
          await api.verifySuperAdminSession(payload);
        // console.log(registerationResponse);
        if (registerationResponse?.token) {
          axios.defaults.headers.common["Authorization"] =
            registerationResponse?.token;
          if (registerationResponse?.role) {
            setAdminType(registerationResponse?.role);
            setAdminPermissions(registerationResponse?.permissions || []);
          }
        } else {
          dispatch(setAdmin({}));
          setSubsData({});
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      }
      setLoader(false);
    } catch (error) {
      alert.show("Session Expired");
      setLoader(false);
      dispatch(setAdmin({}));
      setSubsData({});
      localStorage.removeItem("token");
      window.location.href = "/";
    }
  };

  useEffect(() => {
    if (
      adminStore?.admin?.admin?.role == "mackAdmin777" ||
      adminStore?.admin?.admin?.role == "sackAdmin755" ||
      adminStore?.admin?.admin?.role == "jackAdmin775" ||
      adminStore?.admin?.admin?.role == "livetradestats"
    ) {
      checkSuperAdminSession();
    }
  }, []);

  const checkMessageNotification = async () => {
    let token = localStorage.getItem("token");

    axios.defaults.headers.common["Authorization"] = token;
    const res = await api.getTicketNotification();
    // console.log(res);
    if (res?.success) {
      dispatch(setNotification(res?.hasUnseenMessage || false));
    }
  };
  const checkMessageNotificationAdmin = async () => {
    let token = localStorage.getItem("token");

    axios.defaults.headers.common["Authorization"] = token;
    const res = await api.getTicketNotificationAdmin();
    // console.log("res");
    // console.log(res);
    if (res?.success) {
      dispatch(setNotification(res?.hasUnseenMessage || false));
    }
  };

  // useEffect(() => {
  //   if (userStore?.users?.user?._id) {
  //     checkMessageNotification();
  //   }
  // }, [userStore?.users]);

  useEffect(() => {
    if (adminStore?.admin?.admin?.role == "sackAdmin755") {
      checkMessageNotificationAdmin();
    }
  }, [adminStore?.admin]);

  useEffect(() => {
    createChat({
      webhookUrl:
        "https://chatbot.capitalmediausa.com/webhook/81fa6b33-efd9-4e4a-ac1c-4e1584c996d9/chat",

      initialMessages: [
        "Hi there! 👋",
        "I’m here from Team Waqar Zaka. Here to help you 24/7.",
      ],
      i18n: {
        en: {
          title: "Hi there! 👋",
          subtitle: "I’m here from Team Waqar Zaka. Here to help you 24/7.",
        },
      },
      theme: {
        primary: "#895aef", // Tailwind blue-500
        background: "#ffffff",
        userMessage: {
          background: "#895aef",
          text: "#ffffff",
        },
        botMessage: {
          background: "#f3f4f6",
          text: "#111827",
        },
      },
      position: "left",
      button: {
        backgroundColor: "#10b981", // bubble background
        iconColor: "#ffffff", // chat icon (message bubble) color
        position: "bottom-left", // 👈 explicit position
      },
    });
  }, []);

  return (
    <div className="App">
      {adminStore?.admin?.admin?.email && adminType ? (
        <div id="wrapper">
          <Sidebar adminType={adminType} permissions={adminPermissions} />
          <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
              <NavbarAdmin />
              <Routes>
                {adminType == "sackAdmin755" && (
                  <>
                    <Route
                      exact={true}
                      path="/admin/users"
                      element={<UsersSupport adminType={adminType} />}
                    />
                    <Route
                      exact={true}
                      path="/admin/paid-users"
                      element={<SupportPaidUsers adminType={adminType} />}
                    />
                    <Route
                      exact={true}
                      path="/admin/support"
                      element={<AdminSupportTicket adminType={adminType} />}
                    />
                    <Route
                      exact={true}
                      path="/admin/support/ticket/:id"
                      element={
                        <TicketdetailAdmin
                          adminType={adminType}
                          checkMessageNotificationAdmin={
                            checkMessageNotificationAdmin
                          }
                        />
                      }
                    />
                    <Route
                      exact={true}
                      path="/admin/support/dataInfo"
                      element={<DataInfoSupport adminType={adminType} />}
                    />
                    <Route
                      exact={true}
                      path="/admin/get/support"
                      element={<AdminSupportOnline />}
                    />
                  </>
                )}
                {adminType == "mackAdmin777" &&
                  adminStore?.admin?.admin?.email == "stats@waqarzaka.net" && (
                    <>
                      <Route
                        exact={true}
                        path="/waqarzaka/stats"
                        element={<WaqarStats />}
                      />
                      <Route
                        exact={true}
                        path="/waqarzaka/yubit-referrals"
                        element={<YubitReferrals />}
                      />
                    </>
                  )}
                {adminType == "mackAdmin777" &&
                  adminStore?.admin?.admin?.email != "stats@waqarzaka.net" && (
                    <>
                      <Route
                        exact={true}
                        path="/admin/datainfo"
                        element={<DataInfo />}
                      />
                      <Route
                        exact={true}
                        path="/admin/all-admins"
                        element={<SuperAdminAllSupport />}
                      />
                      <Route
                        exact={true}
                        path="/admin/check-stripe-subscription"
                        element={<AdminSearchStripeSubs />}
                      />
                      <Route
                        exact={true}
                        path="/admin/users"
                        element={<Users adminType={adminType} />}
                      />
                      <Route
                        exact={true}
                        path="/admin/duplicate-users"
                        element={<DuplicateUsers adminType={adminType} />}
                      />
                      <Route
                        exact={true}
                        path="/admin/consent/users"
                        element={<UsersConsent adminType={adminType} />}
                      />
                      <Route
                        exact={true}
                        path="/admin/consent/subscription"
                        element={<SubscriptionConsent adminType={adminType} />}
                      />
                      <Route
                        exact={true}
                        path="/admin/consent/unathorize"
                        element={<UnAuthTransConsent adminType={adminType} />}
                      />
                      <Route
                        exact={true}
                        path="/admin/member-feedback"
                        element={<MemberFeedback adminType={adminType} />}
                      />
                      <Route
                        exact={true}
                        path="/admin/wallet-users"
                        element={<WalletUsers />}
                      />
                      <Route
                        exact={true}
                        path="/admin/paid-users"
                        element={<PaidUsers adminType={adminType} />}
                      />
                      <Route
                        exact={true}
                        path="/admin/direct-paid-users"
                        element={<DirectPaidUsers adminType={adminType} />}
                      />
                      <Route
                        exact={true}
                        path="/admin/user-paid-by-admin"
                        element={<UserPaidByAdmin />}
                      />
                      <Route
                        exact={true}
                        path="/admin/unsubscribed-users"
                        element={<UnSubscribedUsers />}
                      />
                      <Route
                        exact={true}
                        path="/admin/user-payment-history"
                        element={<AdminPaymentHistory />}
                      />
                      <Route
                        exact={true}
                        path="/admin/support"
                        element={<AdminSupportTicket adminType={adminType} />}
                      />
                      <Route
                        exact={true}
                        path="/admin/support/ticket/:id"
                        element={
                          <TicketdetailAdmin
                            adminType={adminType}
                            checkMessageNotificationAdmin={
                              checkMessageNotificationAdmin
                            }
                          />
                        }
                      />
                      <Route
                        exact={true}
                        path="/admin/support-activity"
                        element={<SupportRecentActivity />}
                      />
                      <Route
                        exact={true}
                        path="/admin/ticket-feedback"
                        element={<TicketFeedbackAdmin />}
                      />
                      <Route
                        exact={true}
                        path="/admin/blacklist-email"
                        element={<BlacklistEmail />}
                      />
                      <Route
                        exact={true}
                        path="/admin/email-logs"
                        element={<EmailLogs />}
                      />
                      <Route
                        exact={true}
                        path="/admin/trade-directory"
                        element={<TradeDirectory />}
                      />
                      <Route
                        exact={true}
                        path="/admin/polls"
                        element={<PollAdmin />}
                      />
                      <Route
                        exact={true}
                        path="/admin/live-trades"
                        element={<AdminLiveTrades />}
                      />
                    </>
                  )}
                {/* <Route exact={true} path="/admin/survey" element={<AllSurvey />} /> */}
                {adminStore?.admin?.admin?.email != "stats@waqarzaka.net" && (
                  <>
                    <Route
                      exact={true}
                      path="/admin/sendmail"
                      element={<PromotionMail />}
                    />
                    <Route
                      exact={true}
                      path="/admin/sendmail-paid-users"
                      element={<MailToPaidUsers />}
                    />
                    <Route
                      exact={true}
                      path="/admin/sendmail-non-paid-users"
                      element={<MailToNonPaidUsers />}
                    />
                    <Route
                      exact={true}
                      path="/admin/forget-pass"
                      element={<AdminForgetPass />}
                    />
                    <Route
                      exact={true}
                      path="/admin/send-birthday-wish"
                      element={<MailToBirthdayUsers />}
                    />
                    <Route
                      exact={true}
                      path="/admin/send-mail-paid"
                      element={<SendPaidMail />}
                    />
                    <Route
                      exact={true}
                      path="/admin/send-mail-otp"
                      element={<SendOTPMail />}
                    />
                    <Route
                      exact={true}
                      path="/admin/send-mail-custom"
                      element={<CustomMail />}
                    />
                    {/* <Route exact={true} path="/admin/sendmail-tup-locker" element={<TupLokersMail />} /> */}
                    {/* <Route exact={true} path="/admin/tup-locked" element={<LockersList />} /> */}
                    <Route
                      element={
                        <PermissionRoutes
                          permission="crypto"
                          permissions={adminPermissions}
                          adminType={adminType}
                        />
                      }
                    >
                      <Route
                        exact={true}
                        path="/admin/addpost"
                        element={<AddPost />}
                      />
                    </Route>
                    <Route
                      element={
                        <PermissionRoutes
                          permission="crypto"
                          permissions={adminPermissions}
                          adminType={adminType}
                        />
                      }
                    >
                      <Route
                        exact={true}
                        path="/admin/signals"
                        element={<AllAdminPost />}
                      />
                    </Route>
                    <Route
                      exact={true}
                      path="/admin/broadcast"
                      element={<AdminBroadcast />}
                    />
                    <Route
                      element={
                        <PermissionRoutes
                          permission="education"
                          permissions={adminPermissions}
                          adminType={adminType}
                        />
                      }
                    >
                      <Route
                        exact={true}
                        path="/admin/video"
                        element={<AdminVideo />}
                      />
                    </Route>
                    <Route
                      element={
                        <PermissionRoutes
                          permission="live-session"
                          permissions={adminPermissions}
                          adminType={adminType}
                        />
                      }
                    >
                      <Route
                        exact={true}
                        path="/admin/live-session"
                        element={<AdminLiveSession />}
                      />
                    </Route>
                    <Route
                      element={
                        <PermissionRoutes
                          permission="stock"
                          permissions={adminPermissions}
                          adminType={adminType}
                        />
                      }
                    >
                      <Route
                        exact={true}
                        path="/admin/stocks"
                        element={<AllAdminStocks />}
                      />
                    </Route>
                    <Route
                      element={
                        <PermissionRoutes
                          permission="market"
                          permissions={adminPermissions}
                          adminType={adminType}
                        />
                      }
                    >
                      <Route
                        exact={true}
                        path="/admin/market"
                        element={<AllAdminMarket />}
                      />
                    </Route>
                    <Route
                      element={
                        <PermissionRoutes
                          permission="godzilla"
                          permissions={adminPermissions}
                          adminType={adminType}
                        />
                      }
                    >
                      <Route
                        exact={true}
                        path="/admin/godzilla"
                        element={<AdminGodzilla />}
                      />
                      <Route
                        exact={true}
                        path="/admin/general"
                        element={<AdminGeneral />}
                      />
                    </Route>
                    <Route
                      element={
                        <PermissionRoutes
                          permission="godzilla"
                          permissions={adminPermissions}
                          adminType={adminType}
                        />
                      }
                    >
                      <Route
                        exact={true}
                        path="/admin/check-godzilla"
                        element={<CheckGodzillaAccess />}
                      />
                    </Route>
                    <Route
                      element={
                        <PermissionRoutes
                          permission="subscryption-data"
                          permissions={adminPermissions}
                          adminType={adminType}
                        />
                      }
                    >
                      <Route
                        exact={true}
                        path="/admin/check-stripe-data"
                        element={<CheckCustomerDataStripe />}
                      />
                    </Route>
                    <Route
                      element={
                        <PermissionRoutes
                          permission="trade-summary"
                          permissions={adminPermissions}
                          adminType={adminType}
                        />
                      }
                    >
                      <Route
                        exact={true}
                        path="/admin/create-trade-summary"
                        element={<TradeSummary />}
                      />
                    </Route>
                    <Route
                      element={
                        <PermissionRoutes
                          permission="trade-summary"
                          permissions={adminPermissions}
                          adminType={adminType}
                        />
                      }
                    >
                      <Route
                        exact={true}
                        path="/admin/trade-summary"
                        element={<AdminSummary />}
                      />
                    </Route>
                    <Route
                      element={
                        <PermissionRoutes
                          permission="mobile-banner"
                          permissions={adminPermissions}
                          adminType={adminType}
                        />
                      }
                    >
                      <Route
                        exact={true}
                        path="/admin/mobile/banner"
                        element={<BannerAdmin />}
                      />
                    </Route>
                    <Route
                      element={
                        <PermissionRoutes
                          permission="push-notification"
                          permissions={adminPermissions}
                          adminType={adminType}
                        />
                      }
                    >
                      <Route
                        exact={true}
                        path="admin/mobile/push-notification"
                        element={<PushNotification />}
                      />
                    </Route>
                    <Route
                      exact={true}
                      path="/admin/mobile/notice"
                      element={<NoticeAdmin />}
                    />
                    {/* <Route
                      element={
                        <PermissionRoutes
                          permission="challenge"
                          permissions={adminPermissions}
                          adminType={adminType}
                        />
                      }
                    >
                      <Route
                        exact={true}
                        path="/admin/challenge-plans"
                        element={<ChallengePlan />}
                      />
                    </Route>
                    <Route
                      element={
                        <PermissionRoutes
                          permission="challenge"
                          permissions={adminPermissions}
                          adminType={adminType}
                        />
                      }
                    >
                      <Route
                        exact={true}
                        path="/admin/challenges"
                        element={<ChallengesAdmin />}
                      />
                    </Route>
                    <Route
                      element={
                        <PermissionRoutes
                          permission="challenge"
                          permissions={adminPermissions}
                          adminType={adminType}
                        />
                      }
                    >
                      <Route
                        exact={true}
                        path="/admin/challenges/user/:userId"
                        element={<ChallengesAdminByUserId />}
                      />
                    </Route> */}
                    {/* <Route
                  exact={true}
                  path="/admin/contact"
                  element={<ContactSupAdmin />}
                /> */}
                    <Route
                      exact={true}
                      path="/admin/yearly-contact-form"
                      element={<AdminYearlyContact />}
                    />
                    <Route
                      exact={true}
                      path="/admin/template"
                      element={<AddTemplate adminType={adminType} />}
                    />
                    <Route
                      exact={true}
                      path="/admin/user-logs"
                      element={<AdminUserLogs />}
                    />
                    <Route
                      exact={true}
                      path="/admin/send-push-notification"
                      element={<CustomPushNotification />}
                    />
                  </>
                )}
                {adminType == "livetradestats" && (
                  <>
                    <Route
                      exact={true}
                      path="/live-trading/stats"
                      element={<AdminLiveTrades />}
                    />
                    <Route
                      exact={true}
                      path="/live-trading/tradingview"
                      element={<AdminLiveTradesTV />}
                    />
                  </>
                )}
              </Routes>
            </div>
          </div>
        </div>
      ) : location.pathname == "/portfolio/connect" ||
        location.pathname.includes("/portfolio/dashboard") ||
        location.pathname.includes("/portfolio/tx") ? (
        <>
          <WagmiProvider config={config}>
            <QueryClientProvider client={queryClient}>
              <Routes>
                <Route
                  exact={true}
                  path="/portfolio/connect"
                  element={<ConnectPage />}
                />
                <Route
                  exact={true}
                  path="/portfolio/*"
                  element={<PortfolioDashboard />}
                />
              </Routes>
            </QueryClientProvider>
          </WagmiProvider>
        </>
      ) : (
        <>
          <NavbarNew
            show={show}
            setShow={setShow}
            SubsData={SubsData}
            setSubsData={setSubsData}
          />
          <Routes>
            {/* <Route exact={true} path="/" element={<Home />} /> */}
            <Route exact={true} path="/" element={<HomeNew />} />
            <Route
              exact={true}
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route
              exact={true}
              path="/unauthorized-transaction"
              element={<UnauthTransaction />}
            />
            <Route
              exact={true}
              path="/privacy-policy"
              element={<PrivacyPolicy />}
            />
            {/* <Route exact={true} path="/survey" element={<Survey />} /> */}
            <Route element={<AuthOnlyUserRoutes />}>
              <Route
                exact={true}
                path="/dashboard"
                element={<UserPost SubsData={SubsData} />}
              />
            </Route>
            {/* <Route element={<AuthOnlyUserRoutes />}>
              <Route
                exact={true}
                path="/indicators"
                element={<Indicators SubsData={SubsData} />}
              />
            </Route> */}
            <Route element={<AuthOnlyUserRoutes />}>
              <Route
                exact={true}
                path="/profile"
                element={<ProfilePage SubsData={SubsData} />}
              />
            </Route>
            {/* <Route element={<AuthOnlyUserRoutes />}>
              <Route
                exact={true}
                path="/contact-support"
                element={<ContactSupport SubsData={SubsData} />}
              />
            </Route> */}
            <Route element={<AuthNotLoginRoutes />}>
              <Route
                exact={true}
                path="/signup"
                element={<Signup setSubsData={setSubsData} />}
              />
            </Route>
            {/* <Route element={<AuthNotLoginRoutes />}>
            </Route> */}
            <Route
              exact={true}
              path="/login"
              element={<Login setSubsData={setSubsData} />}
            />
            <Route element={<AuthNotLoginRoutes />}>
              <Route
                exact={true}
                path="/master-login"
                element={<LoginUserByAdmin setSubsData={setSubsData} />}
              />
            </Route>
            <Route element={<AuthNotLoginRoutes />}>
              <Route
                exact={true}
                path="/forget-password"
                element={<ForgetPass />}
              />
            </Route>
            <Route element={<AuthNotLoginRoutes />}>
              <Route
                exact={true}
                path="/reset-password/:id"
                element={<ResetPass />}
              />
            </Route>
            <Route element={<AuthOnlyUserRoutes />}>
              <Route
                exact={true}
                path="/checkout"
                element={<Checkout SubsData={SubsData} />}
              />
            </Route>
            <Route element={<AuthOnlyUserRoutes />}>
              <Route
                exact={true}
                path="/subscription/history"
                element={
                  <PayHistoryUser
                    SubsData={SubsData}
                    setSubsData={setSubsData}
                  />
                }
              />
              <Route
                exact={true}
                path="/support"
                element={<SupportUser SubsData={SubsData} />}
              />
              <Route
                exact={true}
                path="/support/create-ticket"
                element={<CreateTicket />}
              />
              <Route
                exact={true}
                path="/support/ticket/:id"
                element={
                  <Ticketdetail
                    checkMessageNotification={checkMessageNotification}
                  />
                }
              />
            </Route>
            <Route
              exact={true}
              path="/admin-login"
              element={<AdminLogin setAdminType={setAdminType} />}
            />
            <Route
              exact={true}
              path="/super-admin-login"
              element={<SuperAdminLogin setAdminType={setAdminType} />}
            />
            <Route
              exact={true}
              path="/waqar-login"
              element={<WaqarLogin setAdminType={setAdminType} />}
            />
            <Route
              exact={true}
              path="/live-trade-login"
              element={<LiveTradeLogin setAdminType={setAdminType} />}
            />
            <Route
              exact={true}
              path="/support-admin-login"
              element={
                <SupportAdminLogin
                  setAdminType={setAdminType}
                  setAdminPermissions={setAdminPermissions}
                />
              }
            />
            <Route exact={true} path="/portfolio" element={<Portfolio />} />
            <Route
              exact={true}
              path="/liquidity-radar"
              element={
                userStore?.users?.user?._id ? (
                  <LiquidityRadar />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
            <Route
              exact={true}
              path="/market-overview"
              element={<MarketOverview />}
            />
            <Route
              exact={true}
              path="/calculators"
              element={<CalculatorMain />}
            />
          </Routes>
          <FooterNew show={show} setShow={setShow} />
          {/* {location.pathname == "/home" ? (
          ) : (
            <Footer show={show} setShow={setShow} />
          )} */}
        </>
      )}
      {/* <CokieModal /> */}
      {/* {SubsData?.isSubscription && <PaidFeedback SubsData={SubsData} />} */}
      {userStore?.users?.user?._id && <ConsentsModal />}
      {/* {userStore?.users?.user?._id && <NoticeModal />} */}

      {loader && <Loader />}
      <div className="intercomHelpText" id="intercomHelpText">
        Need Help?
      </div>
    </div>
  );
}

export default App;
